export default __webpack_public_path__ + "static/media/image4tum.81af237d.jpg";